export default {
      id: "help__notices_icon-usage",
      viewBox: "0 0 49 45",
      url: __webpack_public_path__ + "img/icons.svg#help__notices_icon",
      toString: function () {
        return this.url;
      }
    }